import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditPlansResolverErrorStatesEnum {
    GetParentFailed = ErrorStateScheduleEnum.PanelAccountsEditPlansResolverErrorStatesStartIndex,
    GetPlansFailed,
    GetPlanAvailableTriggersFailed,
    GetPreviousNonWorkingDayFailed,
    GetReportFailed
}
